import React from 'react';
import { XIcon } from 'lucide-react';
const problems = ['Spending hours every weekend programming functional sessions from scratch.', 'Running out of exercise ideas and repeating the same tired circuits.', 'Struggling to scale workouts for mixed-level groups in real time.', 'Arriving at the gym unprepared and being forced to improvise.'];
export function ProblemSection() {
  return <section className="bg-ink-900 px-5 py-20" data-id="element-154" data-mp="39hcqbrr9cf51">
      <div className="mx-auto max-w-4xl text-center" data-id="element-155" data-mp="39g2ul97vnj1k">
        <p className="text-[11px] font-semibold uppercase tracking-[.22em] text-clay-300" data-id="element-156" data-mp="35h2alndnyacz">
          The coaching trap
        </p>
        <h2 className="mt-4 font-display text-[2.1rem] font-semibold uppercase leading-[1.02] tracking-[.01em] text-white sm:text-5xl" data-id="element-157" data-mp="3jfjxxjznpkud">
          Do these challenges sound familiar?
        </h2>
        <div className="mt-11 grid gap-3 text-left sm:grid-cols-2" data-id="element-158" data-mp="1p2klfzqkp6rb">
          {problems.map(problem => <div key={problem} className="flex gap-3 border border-white/10 bg-ink-800 p-5" data-id="element-159" data-mp="1k4sjecw7s49e">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay-400" data-id="element-160" data-mp="oc7xxhylgfjc" />
              <p className="text-sm leading-relaxed text-stone-200" data-id="element-161" data-mp="oa3u100p3gj2">
                {problem}
              </p>
            </div>)}
        </div>
        <p className="mx-auto mt-11 max-w-2xl font-display text-2xl font-medium italic leading-snug text-clay-300 sm:text-3xl" data-id="element-162" data-mp="x4s1mwtqtab1">
          Stop winging your sessions. Start leading with a proven roadmap.
        </p>
      </div>
    </section>;
}